import React, { useEffect, useState } from "react";

//UI Material
import { Breadcrumbs, Button, Grid, Link } from "@mui/material";

//React PDF Renderer
import { BlobProvider } from "@react-pdf/renderer";

//Local components
import ErrorBox from "../Components/ErrorBox";
import PDFDocument from "../Components/basics/PDFDocument";
import QuoteSummary from "../Components/quote-page/QuoteSummary";
import QuoteProductsTable from "../Components/quote-page/QuoteProductsTable";
import QuoteBilling from "../Components/quote-page/QuoteBilling";
import QuoteClient from "../Components/quote-page/QuoteClient";
import DataLoader from "../Components/basics/DataLoader";

//Helpers
import { fetchWithTokenJSONPost } from "../Helpers/network";

//Material Icons
import { Download, Edit } from "@mui/icons-material";

export default function Quote() {
  // ==========> Component States <==========
  //State for store quote data
  const [quoteData, setQuoteData] = useState({});
  //State for loading
  const [isLoading, setIsLoading] = useState(true);
  //State for error case
  const [dataError, setDataError] = useState(false);

  // ==========> Component Functions <==========
  //Function to get order data from db
  const getQuoteData = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(`/quotes/getQuote`, {
        quoteNumber: Number(
          new URLSearchParams(window.location.search).get("id")
        ),
      });
      const jsonResponse = await requestResponse.json();
      setQuoteData(jsonResponse.data);
    } catch (error) {
      setDataError(true);
    }
    setIsLoading(false);
  };

  //The useEffect checks for token validation
  useEffect(() => {
    getQuoteData();
  }, []);

  // ==========> Component <==========
  if (dataError) return <ErrorBox />;
  return isLoading ? (
    <DataLoader />
  ) : (
    <Grid
      container
      spacing={2}
      justifyContent="flex-start"
      textAlign="center"
      sx={{ padding: 2 }}
    >
      <Grid item xs={12} sx={{ mb: 1 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="inherit" href="/quotes">
            Cotizaciones
          </Link>
          <Link underline="hover" color="text.primary" aria-current="page">
            {`Cotización ${quoteData.quoteNumber}`}
          </Link>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12} md={3} xl={2}>
        <QuoteSummary data={quoteData} />
      </Grid>
      <Grid item xs={12} md={9} xl={10}>
        <Grid container spacing={2}>
          <Grid item xs={6} align="left">
            <BlobProvider
              document={
                <PDFDocument
                  data={quoteData}
                  id={quoteData.quoteNumber}
                  expDate={quoteData.expirationDate}
                />
              }
            >
              {({ url }) => (
                <div>
                  <a
                    href={url}
                    download={`cotizacion${quoteData.quoteNumber}.pdf`}
                  >
                    <Button endIcon={<Download />}>Descargar PDF</Button>
                  </a>
                </div>
              )}
            </BlobProvider>
          </Grid>
          <Grid item xs={6} align="right">
            <Button
              endIcon={<Edit />}
              onClick={() => {
                localStorage.setItem("quote", JSON.stringify(quoteData));
                window.location.href = "/new-quote";
              }}
            >
              Editar cotización
            </Button>
          </Grid>
          <Grid item xs={12}>
            <QuoteProductsTable data={quoteData} />
          </Grid>
          <Grid item xs={12} md={6}>
            <QuoteClient data={quoteData} />
          </Grid>
          <Grid item xs={12} md={6}>
            <QuoteBilling data={quoteData} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
